import React from "react";
import {
  ArrowButton,
  Card,
  CardImage,
  DefaultContent,
  HoverContent,
} from "./ProductCard.styles";

interface ProductCardProps {
  title: string;
  subtitle: string;
  description: string;
  image: string;
  to: string;
  imageFit?: "cover" | "contain";
  backgroundColor: string;
  textColor: string;
  buttonColor: string;
  arrowColor: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  subtitle,
  description,
  image,
  to,
  imageFit = "cover",
  backgroundColor,
  textColor,
  buttonColor,
  arrowColor,
}) => {
  return (
    <Card
      to={to}
      aria-label={`${title}. ${subtitle}`}
      $backgroundColor={backgroundColor}
      $textColor={textColor}
    >
      <CardImage
        src={image}
        alt=""
        loading="lazy"
        decoding="async"
        $imageFit={imageFit}
        $backgroundColor={backgroundColor}
      />
      <ArrowButton
        aria-hidden="true"
        $buttonColor={buttonColor}
        $arrowColor={arrowColor}
      >
        <span>Подробнее</span>
        <i className="pi pi-arrow-up-right" />
      </ArrowButton>
      <DefaultContent>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </DefaultContent>
      <HoverContent>
        <p>{description}</p>
      </HoverContent>
    </Card>
  );
};

export default ProductCard;
